import { render, staticRenderFns } from "./ticketManageGet.vue?vue&type=template&id=2b70a5e9"
import script from "./ticketManageGet.vue?vue&type=script&lang=js"
export * from "./ticketManageGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports